import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.values.js";
import { csvParse } from 'd3';
import { getBetaAlarmsApi } from '@/api/betaFolder';

// 異常編碼 → [名稱, 設備層, 說明]；未列者以 alarms.csv 的節點層級分類、名稱顯示編碼
var RC = {
  'C-STR-03': ['串列發電能力衰退', '串列', '相同日照條件下發電量下降，可能為模組劣化、表面髒污或長期遮蔭。'],
  'C-STR-02': ['串列電流偏低', '串列', '可能為局部遮蔭、表面髒污、模組或接頭異常。'],
  'C-MPPT-02': ['MPPT 電流偏低', 'MPPT', '下轄串列失效，或個別弱串拉低整組輸出。'],
  'V-DC-MPPT-02': ['MPPT 電壓偏高', 'MPPT', '可能為最大功率追蹤失效、串列開路或變流器降載。'],
  'V-DC-MPPT-03': ['MPPT 電壓偏低', 'MPPT', '可能為熱斑、遮蔭、旁路二極體導通或電位誘發衰減（PID）。'],
  'INV-WAKEUP-01': ['變流器晨間啟動延遲', '變流器', '可能為直流側啟動電壓不足、串列開路或啟動門檻設定異常。'],
  'C-INV-01': ['變流器無輸出', '變流器', '變流器處於待機狀態，或功率元件（IGBT）故障。'],
  'C-INV-02': ['變流器發電量偏低', '變流器', '可能為過溫或過壓降載、電網調度限制。'],
  'C-INV-03': ['變流器轉換效率偏低', '變流器', '轉換損失增加，可能與溫度、設備老化或調度限制有關。'],
  'CONN-INV-01': ['變流器反覆重啟', '變流器', '可能為電網品質不穩，或變流器保護功能反覆動作。'],
  'CONN-INV-02': ['變流器停機待人工復歸', '變流器', '硬體故障，或保護動作後未自動恢復運轉。'],
  'INV-ISO-01': ['直流側絕緣阻抗偏低', '絕緣與漏電', '直流側模組或纜線可能受潮或破損。'],
  'INV-ISO-02': ['絕緣阻抗較自身歷史明顯下降', '絕緣與漏電', '可能為匯流箱受潮、密封失效或纜線磨損。'],
  'INV-LEAK-02': ['漏電保護告警', '絕緣與漏電', '直流側絕緣破損，與絕緣阻抗偏低屬同一源頭。'],
  'V-AC-HV-01': ['HV 段電錶無電壓', '電錶與電網', '可能為斷路器跳脫、比壓器（PT）故障或電錶讀值異常。'],
  'C-HV-01': ['HV 段電錶功率為零', '電錶與電網', '可能為比流器（CT）故障或電錶讀值異常。'],
  'C-HV-02': ['HV 段電錶功率偏高', '電錶與電網', '可能為比流器或電錶倍率設定錯誤。'],
  'C-HV-03': ['變壓器段損失偏高', '電錶與電網', '線路與變壓器損失偏高，或比流器準確度偏移。'],
  'D-I-SEG-01': ['上下游電流不一致', '電錶與電網', '可能為比流器倍率或電錶參數設定錯誤。']
};
var LEVEL_LAYER = {
  STR: '串列',
  MPPT: 'MPPT',
  INV: '變流器',
  HV: '電錶與電網',
  MV: '電錶與電網',
  LV: '電錶與電網',
  區段: '電錶與電網',
  案場: '案場'
};
var LAYERS = ['全部', '串列', 'MPPT', '變流器', '絕緣與漏電', '電錶與電網', '案場'];
var PUSH = {
  推播: {
    text: '推播',
    cls: 'rc_badgePush'
  },
  合併: {
    text: '七日內已推播',
    cls: 'rc_badgeMuted'
  },
  只顯示: {
    text: '僅顯示',
    cls: 'rc_badgeMuted'
  },
  併入全場單: {
    text: '併入全場單',
    cls: 'rc_badgeSite'
  }
};
var md = function md(d) {
  return d.slice(5).replace('-', '/');
};
var addDays = function addDays(d, n) {
  var t = new Date(d + 'T00:00:00Z');
  t.setUTCDate(t.getUTCDate() + n);
  return t.toISOString().slice(0, 10);
};
// 驗收週＝週五～週四；回該日所屬週的週四
var weekEnd = function weekEnd(d) {
  return addDays(d, (4 - new Date(d + 'T00:00:00Z').getUTCDay() + 7) % 7);
};
var fmtNum = function fmtNum(s) {
  if (s === '' || s == null) return '—';
  var x = Number(s);
  return Number.isFinite(x) ? x.toLocaleString('en-US', {
    maximumFractionDigits: Math.abs(x) >= 100 ? 0 : 3
  }) : s;
};
export default {
  name: 'RootCauseWeekly',
  data: function data() {
    return {
      LAYERS: LAYERS,
      roots: {},
      root: '',
      period: '',
      rows: [],
      layer: '全部',
      onlyPush: false,
      q: '',
      loading: false,
      error: '',
      groupFields: [{
        key: 'name',
        label: '根因'
      }, {
        key: 'layer',
        label: '設備層',
        thClass: 'rc_nowrap',
        tdClass: 'rc_nowrap'
      }, {
        key: 'deviceCount',
        label: '設備數',
        thClass: 'rc_nowrap text-right',
        tdClass: 'rc_num text-right'
      }, {
        key: 'count',
        label: '告警筆數',
        thClass: 'rc_nowrap text-right',
        tdClass: 'rc_num text-right'
      }, {
        key: 'push',
        label: '推播',
        thClass: 'rc_nowrap',
        tdClass: 'rc_nowrap'
      }],
      deviceFields: [{
        key: 'device',
        label: '設備',
        tdClass: 'rc_num rc_nowrap'
      }, {
        key: 'days',
        label: '出現天數',
        tdClass: 'rc_nowrap'
      }, {
        key: 'value',
        label: '最近一次 量測值／比較基準',
        thClass: 'rc_nowrap',
        tdClass: 'rc_value'
      }, {
        key: 'push',
        label: '推播狀態',
        thClass: 'rc_nowrap',
        tdClass: 'rc_nowrap'
      }, {
        key: 'links',
        label: '連動註記（同一源頭之現象）'
      }]
    };
  },
  computed: {
    rootOptions: function rootOptions() {
      return Object.keys(this.roots).sort(function (a, b) {
        return a.length - b.length || a.localeCompare(b);
      });
    },
    days: function days() {
      return this.roots[this.root] || [];
    },
    daysDesc: function daysDesc() {
      return this.days.slice().reverse();
    },
    periods: function periods() {
      var ends = _toConsumableArray(new Set(this.days.map(weekEnd))).sort().reverse();
      return ends.map(function (e) {
        var s = addDays(e, -6);
        return {
          value: s + '~' + e,
          text: "".concat(md(s), "\uFF5E").concat(md(e))
        };
      });
    },
    filtered: function filtered() {
      var _this = this;
      var q = this.q.trim().toLowerCase();
      return this.rows.filter(function (r) {
        return (_this.layer === '全部' || r.layer === _this.layer) && (!_this.onlyPush || r.push === '推播') && (!q || [r.name, r.code, r.device, r.cause, r.links.join(' ')].join(' ').toLowerCase().includes(q));
      });
    },
    tiles: function tiles() {
      var rows = this.rows;
      return [{
        k: '主告警',
        v: "".concat(rows.length, " \u7B46")
      }, {
        k: '推播',
        v: "".concat(rows.filter(function (r) {
          return r.push === '推播';
        }).length, " \u7B46"),
        cls: 'push'
      }, {
        k: '根因類別',
        v: "".concat(new Set(rows.map(function (r) {
          return r.code;
        })).size, " \u985E")
      }, {
        k: '涉及設備',
        v: "".concat(new Set(rows.map(function (r) {
          return r.device;
        })).size, " \u53F0\uFF0F\u4E32")
      }];
    },
    groups: function groups() {
      var byCode = new Map();
      var _iterator = _createForOfIteratorHelper(this.filtered),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var r = _step.value;
          if (!byCode.has(r.code)) byCode.set(r.code, []);
          byCode.get(r.code).push(r);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return _toConsumableArray(byCode.entries()).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          code = _ref2[0],
          list = _ref2[1];
        var byDev = new Map();
        var _iterator2 = _createForOfIteratorHelper(list),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var r = _step2.value;
            if (!byDev.has(r.device)) byDev.set(r.device, []);
            byDev.get(r.device).push(r);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        var devices = _toConsumableArray(byDev.entries()).map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            device = _ref4[0],
            arr = _ref4[1];
          arr.sort(function (a, b) {
            return a.date.localeCompare(b.date);
          });
          var last = arr[arr.length - 1];
          var ds = _toConsumableArray(new Set(arr.map(function (a) {
            return a.date;
          })));
          var pushed = arr.find(function (a) {
            return a.push === '推播';
          });
          var shown = pushed || last;
          return {
            device: device,
            days: ds.length,
            span: ds.length > 2 ? "".concat(md(ds[0]), "\uFF5E").concat(md(ds[ds.length - 1])) : ds.map(md).join('、'),
            value: "".concat(fmtNum(last.x), " \uFF0F ").concat(fmtNum(last.base)),
            baseKind: last.baseKind,
            push: PUSH[shown.push] || {
              text: shown.push || '—',
              cls: 'rc_badgeMuted'
            },
            pushNote: shown.pushNote,
            links: _toConsumableArray(new Set(arr.flatMap(function (a) {
              return a.links;
            })))
          };
        }).sort(function (a, b) {
          return b.days - a.days || a.device.localeCompare(b.device);
        });
        var first = list[0];
        return {
          code: code,
          name: first.name,
          layer: first.layer,
          desc: first.desc,
          cause: first.cause,
          action: first.action,
          feature: _toConsumableArray(new Set(list.map(function (r) {
            return r.feature;
          }).filter(Boolean))).join('、'),
          deviceCount: byDev.size,
          count: list.length,
          push: list.filter(function (r) {
            return r.push === '推播';
          }).length,
          devices: devices,
          _showDetails: false
        };
      }).sort(function (a, b) {
        return b.count - a.count || a.code.localeCompare(b.code);
      });
    }
  },
  watch: {
    rootOptions: function rootOptions(list) {
      if (!list.includes(this.root)) this.root = list[0] || '';
    },
    root: function root() {
      var _this$periods$;
      this.period = ((_this$periods$ = this.periods[0]) === null || _this$periods$ === void 0 ? void 0 : _this$periods$.value) || '';
    },
    period: function period() {
      this.loadRows();
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getBetaAlarmsApi({});
            case 3:
              _this2.roots = _context.sent.roots;
              _context.next = 9;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              _this2.error = (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.msg) || (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message) || '無法讀取每日結果';
            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 6]]);
    }))();
  },
  methods: {
    loadRows: function loadRows() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$period$split, _this3$period$split2, from, to, _yield$getBetaAlarmsA, files;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this3.root || !_this3.period)) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                _this3$period$split = _this3.period.split('~'), _this3$period$split2 = _slicedToArray(_this3$period$split, 2), from = _this3$period$split2[0], to = _this3$period$split2[1];
                _this3.loading = true;
                _this3.error = '';
                _context2.prev = 5;
                _context2.next = 8;
                return getBetaAlarmsApi({
                  root: _this3.root,
                  from: from,
                  to: to
                });
              case 8:
                _yield$getBetaAlarmsA = _context2.sent;
                files = _yield$getBetaAlarmsA.files;
                _this3.rows = Object.values(files).flatMap(function (text) {
                  return csvParse(text.replace(/^\uFEFF/, ''));
                }).map(function (r) {
                  var rc = RC[r['異常編碼']];
                  return {
                    date: r['事件日期'],
                    device: r['設備識別'],
                    code: r['異常編碼'],
                    name: rc ? rc[0] : r['異常編碼'],
                    layer: rc ? rc[1] : LEVEL_LAYER[r['節點層級']] || r['節點層級'],
                    desc: rc ? rc[2] : '',
                    feature: r.Feature,
                    push: r['候選_推播'],
                    pushNote: r['候選_推播說明'],
                    x: r['量測值'],
                    base: r['比較基準值'],
                    baseKind: r['基準種類'],
                    cause: r['可能根因'],
                    action: r['處置建議'],
                    links: r['候選_連動註記'] ? [r['候選_連動註記']] : r['現象清單'] ? [r['現象清單']] : []
                  };
                });
                _context2.next = 16;
                break;
              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](5);
                _this3.error = (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.msg) || (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) || '無法讀取每日結果';
              case 16:
                _context2.prev = 16;
                _this3.loading = false;
                return _context2.finish(16);
              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[5, 13, 16, 19]]);
      }))();
    }
  }
};